var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoffee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.6,
    height: 21.6,
    viewBox: "0 0 22.6 21.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "coffee",
    transform: "translate(-1.2 -0.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2301",
    "data-name": "Path 2301",
    d: "M19,16.8H18a.8.8,0,0,1,0-1.6h1a3.2,3.2,0,1,0,0-6.4H18a.8.8,0,0,1,0-1.6h1a4.8,4.8,0,0,1,0,9.6Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2302",
    "data-name": "Path 2302",
    d: "M2,7.2H18a.8.8,0,0,1,.8.8v9A4.805,4.805,0,0,1,14,21.8H6A4.805,4.805,0,0,1,1.2,17V8A.8.8,0,0,1,2,7.2ZM17.2,8.8H2.8V17A3.2,3.2,0,0,0,6,20.2h8A3.2,3.2,0,0,0,17.2,17Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_1297",
    "data-name": "Line 1297",
    d: "M0,3.8A.8.8,0,0,1-.8,3V0A.8.8,0,0,1,0-.8.8.8,0,0,1,.8,0V3A.8.8,0,0,1,0,3.8Z",
    transform: "translate(6 1)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_1298",
    "data-name": "Line 1298",
    d: "M0,3.8A.8.8,0,0,1-.8,3V0A.8.8,0,0,1,0-.8.8.8,0,0,1,.8,0V3A.8.8,0,0,1,0,3.8Z",
    transform: "translate(10 1)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_1299",
    "data-name": "Line 1299",
    d: "M0,3.8A.8.8,0,0,1-.8,3V0A.8.8,0,0,1,0-.8.8.8,0,0,1,.8,0V3A.8.8,0,0,1,0,3.8Z",
    transform: "translate(14 1)",
    fill: "#333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/coffee.0a9414305a931511b54b04ea3dbaf12b.svg";
export { ForwardRef as ReactComponent };